import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
/**
 * @author yili
 * @fileoverview 全局顶部
 */

import { defineComponent, reactive, onMounted, toRefs } from "vue";
// assets
import kt1Url from "@/assets/img/m/kt1.png";
import kt2Url from "@/assets/img/m/kt2.png";

// api
import { reportData } from "@/api/common";
export default defineComponent({
  name: "MHeaderBox",
  props: {
    // 是否下载按钮
    isDownLoad: {
      type: Boolean,
      default: true
    },
    isBanner: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup(props) {
    const {
      isDownLoad,
      isBanner
    } = toRefs(props);

    // 组件状态
    const state = reactive({
      isMobbile: false
    });
    onMounted(() => {
      state.isMobbile = window.screen.width < 1200;
    });
    /**
     * 事件 - 点击下载
     */
    function download() {
      const params = {
        event_name: "click",
        click_id: 2,
        click_type: 3
      };
      reportData(params).then(() => {});
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        copy("http://h5-tg.shiyuegame.com/2049.html?sy_ad_id=1203193");
      } else {
        window.open("http://h5-tg.shiyuegame.com/2049.html?sy_ad_id=1203193");
      }
    }

    // 复制
    function copy(textValue) {
      // 动态创建 textarea 标签
      const textarea = document.createElement("textarea");
      // 将该 textarea 设为 readonly 防止 iOS 下自动唤起键盘，同时将 textarea 移出可视区域
      textarea.readOnly = "readonly";
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      // 将要 copy 的值赋给 textarea 标签的 value 属性
      textarea.value = textValue;
      // 将 textarea 插入到 body 中
      document.body.appendChild(textarea);
      // 选中值并复制
      textarea.select();
      const result = document.execCommand("Copy");
      if (result) {
        alert("复制下载地址成功，去浏览器打开！");
      }
      document.body.removeChild(textarea);
    }
    return () => {
      const headFixBox = _createVNode("div", {
        "class": "m-fixed bg-contain bg-center"
      }, [_createVNode("div", {
        "class": "logo-box"
      }, [_createVNode("div", {
        "class": "icon bg-contain bg-center"
      }, null), _createVNode("div", {
        "class": "title-box"
      }, [_createVNode("h4", {
        "class": "title"
      }, [_createTextVNode("\u957F\u5B89\u5E7B\u60F3")]), _createVNode("p", {
        "class": "intro"
      }, [_createTextVNode("\u7AD6\u7248\u56DE\u5408\u6293\u5996\u624B\u6E38")])]), _createVNode("a", {
        "href": "https://cahx.shiyue.com/m",
        "class": "full-link"
      }, null)]), isDownLoad.value ? _createVNode("div", {
        "class": "download bg-contain bg-center breathe-animation",
        "onClick": download
      }, [_createVNode("a", {
        "target": "_blank",
        "class": "full-link"
      }, null)]) : ""]);
      const bannerBox = isBanner.value ? _createVNode("div", {
        "class": "banner-box"
      }, [_createVNode("img", {
        "class": "kt1",
        "src": kt1Url
      }, null), _createVNode("img", {
        "class": "kt2",
        "src": kt2Url
      }, null)]) : "";
      return _createVNode("div", {
        "class": "cahx-m-header"
      }, [headFixBox, bannerBox]);
    };
  }
});